import { selectAccountId } from 'affiny-core/redux/selectors/accountSelectors';
import { call, select } from 'redux-saga/effects';
import { VisitsResource } from '../../../core/resources/visits.resource';
import { IApiVisitResult } from '../../../models/interactions/visits/visit.types';
import { interactionsNormalizer } from '../interactions.normalizer';

export function* postVisit(otherAccountId: string) {
  const myAccountId: string = yield select(selectAccountId);

  return yield call(VisitsResource.postVisit, myAccountId, otherAccountId);
}
export const VISITS_PAGE_SIZE = 10;

export function* getVisits(
  pageNumber: number,
  pageSize: number = VISITS_PAGE_SIZE
) {
  const myAccountId: string = yield select(selectAccountId);
  let result: IApiVisitResult = yield call(
    VisitsResource.getVisits,
    myAccountId,
    pageNumber,
    pageSize
  );

  // TMP fix: until back is fixed
  result = {
    ...result,
    meta: {
      ...result.meta,
      pagination: {
        ...result.meta.pagination,
        current_page: pageNumber,
      },
    },
  };

  return interactionsNormalizer(result);
}
